export const envPath = process.env.REACT_APP_ENV;//env
export const apiUrl = process.env.REACT_APP_API_URL;// base path url
export const siteUrl = process.env.REACT_APP_SITE_URL;//site urll
export const domainName = process.env.REACT_APP_DOMAIN_NAME // domain name base url
export const gudshoTutorials = "https://www.gudsho.com/app/mirrorfly";//docs page
export const docsPage = "https://www.mirrorfly.com/docs/";//docs page
export const secretKEY = process.env.REACT_APP_SECRET_KEY;//encrpt and decrypt key
export const recaptchaKey = process.env.REACT_APP_RECAPTCHA;//recaptch key
export const stripePkId = process.env.REACT_APP_STRIPE_PK_ID;//frondEnd id
export const uiKitBasePath = process.env.REACT_APP_UI_KIT_URL;//uikit basePath
export const googleTagManagerKey = process.env.REACT_APP_GTM_KEY;
export const socketHost = process.env.REACT_APP_XMPP_SOCKET_HOST;//env e
export const loacteFineUrl = "https://ipapi.co/json/";//alter location find url
export const locationFindUrl = "https://geolocation-db.com/json/";//find loging user location
export const userLoaction = Intl.DateTimeFormat().resolvedOptions().timeZone;//user location
export const contactForSalse = "https://www.mirrorfly.com/contact-sales.php";//contact support team
export const ticketRaise = "https://support.mirrorfly.com/portal/en/newticket";//raise ticket url
export const contactForSalseParams = "https://www.mirrorfly.com/cloud-contact-sales.php?";//contact support team
export const UIKitUrl = "https://s3.ap-south-1.amazonaws.com/app.mirrorfly.com/UIkit.zip";//uikit download
export const docusPageMove = "https://www.mirrorfly.com/docs/#option-1-just-build-a-sample-app";
export const SDKUrl = "https://s3.ap-south-1.amazonaws.com/app.mirrorfly.com/SDK_FILES.zip";//sdkUrl
export const uiKitWeb = "https://s3.ap-south-1.amazonaws.com/app.mirrorfly.com/webSample-app.zip";
export const uiKitIos = "https://s3.ap-south-1.amazonaws.com/app.mirrorfly.com/iosSample-app.zip";
export const SampleAppUrl = "https://s3.ap-south-1.amazonaws.com/app.mirrorfly.com/Sample-app.zip";//sample app downloadUrl-samp
export const fireBaseKeyGenerate = "https://firebase.google.com/docs/cloud-messaging/android/client";
export const fireBaseKeyGenerateIOS = "https://firebase.google.com/docs/cloud-messaging/android/client";
export const uiKitAndroid = "https://s3.ap-south-1.amazonaws.com/app.mirrorfly.com/androidSample-app.zip";
export const iosVoipCertificateMake = "https://developer.apple.com/help/account/create-certificates/create-voip-services-certificates/";
export const iosApnsCertificateMake = "https://developer.apple.com/documentation/usernotifications/setting_up_a_remote_notification_server";

export const loginApi = {
    logIn: "api/login", //Login
    resetPass: "api/password/resetPassword", //resetPassword and create password
    forgetPass: "api/password/resetPassword", //forget assword email trigger
};

/**customer and Teams page user list */
export const customerApi = {
    PalnUrl: "api/customer/plans", //planDetails
    getCusList: "api/customer/list?", //getUser Details
    deleteCus: "api/customer/delete?", //delete user
    updateCus: "api/customer/update?", //userupdate
    createCus: "api/customer/create?", //new userCreate
    getCustomerDetailUrl: "api/customer/details?", //getuser single details
    mediaDownloadUrl: "media/download/", //media download
    updateCusDomainHook: "api/customer/license/update", //update cus domain and hooks
    getRoleAccess: "api/metric/roleAccess/details?",
    saveAndEditRoleAccess: "api/metric/roleAccess/createOrUpdate",
    serverRegion : "api/customer/Configuration/serverRegion?",
    instanceTypeCloud: "api/customer/Configuration/instanceTypeCloud?",
    serverConfigurationStatus: "api/customer/Configuration/serverConfigurationStatus?"
};
/**App release */
export const appRelease = {
    getOrgDetails: "api/customer/organisations?",//get org details
    mediaDownloadUrl: "media/download/", //SDK and DOC Media download url
};

/** dashBoard */
export const dashBoard = {
    quickView: "api/metric/quickOverView?",//Quick view
    analyticView: "api/metric/analyticsOverView?",//analytic view
    recentActivityCustomers: "api/metric/recentActivityCustomers?",//analytic view
    getCallDuration: "api/metric/getCallsDuration",//get call duration passed org id
    getCallUsageDetailsUrl: "api/metric/getTotalCallUsage",//get call useage details
};

export const passwordApi = {//change password apis
    changePwd: "api/customer/changePassword?"//change password
};

export const UpdateProfile = {//change password apis
    profileUpdate: "api/customer/updateProfile?",//change password
    deleteCertificate: "api/customer/Configuration/delete?",//delete ios certificate
    getServerConfigPath: "api/customer/Configuration/details?",//get server configuration details
    updateCustomerServerConfigPath: "api/customer/Configuration/create?",//update server config
    updateSuperAdminServerConfigPath: "api/customer/Configuration/update?",//update server config
    saveOrEditServerConfigPath: "api/customer/Configuration/saveoredit?",//save or edit server config
    revokeApiCredential: "api/customer/Configuration/updateApiPassword?",
    createAccountDeleteRequest: "api/customer/Account/request?",
    deleteRequestStatus: "api/customer/Account/requestStatus?",
    denyDeleteRequest: "api/customer/Account/denyRequest?",
    sendEmailToDevopsTeam: "api/customer/sendEmailToDevopsTeam",
};

export const registerApiUrl = {//register api call
    trialUser: "api/trialUser",
    userValidate: "api/password/validateEmail",//trail user validate
    signupStepOne: "api/trialUser/signup/stepone",
};

export const createTicket = {//raise ticket
    createTicket: "api/customer/submitTicket?"
};

export const moderationApi = {//moderation
    user: "api/moderation/moderation/userList",//user list
    group: "api/moderation/moderation/groupList",//group list
    report: "api/moderation/moderation/reportList",//report list
    blockUserGroup: "api/moderation/moderation/block",//block user or group
    userCredential: "api/moderation/validateAPICredentials",//user credential
    login: "api/moderation/validateAPILogin",//login
    createUser: "api/moderation/validateCreateUserAPIAsAdmin",//createUser
    resetPassword: "api/moderation/resetPassword",//resetPassword
    sendMessage: "api/moderation/validateSendMessageAPIAsUser",//sendMessage
    chatHistory: "api/moderation/validateChatHistoryAPIAsUser",//chatHistory
    deleteUserAccount: "api/moderation/clearValidationData"//deleteUserAccount
};

export const activityLog = {//notification
    adminActivities: "api/metric/getAdminActivities",
    adminActivityFilter: "api/metric/getActivityType"
};

export const themeSettingAPI = {
    getThemeSetting: "api/customer/themesetting?",
    updateThemeSetting: "api/customer/themesetting?"
};

export const workFlowAPI = {
    tenetConfig: "api/customer/tenant-config",
    imageDownloadUrl: "api/customer/downloadUrl",
    uploadImageUrl: "api/customer/uploadFile",
    languageListUrl: "api/customer/languages",
    authenticationListUrl: "api/customer/authenticationType",
}
